module.exports = __webpack_public_path__ + "img/effect-coupon-icon.f873fe4f.png";